import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from "utils/helpers/common/http-methods";
import {
  AddBoardDTO,
  UpdatePasswordDTO,
} from "utils/helpers/models/organization/add-board.dto";
import { AddLinkSpecialization } from "utils/helpers/models/organization/add-link-specialization.dto";
import { AddPermissionDTO } from "utils/helpers/models/organization/add-permission.dto";
import { AddRoomDto } from "utils/helpers/models/organization/add-rooms.dto";
import { AdminDTO } from "utils/helpers/models/organization/admin.dto";
import { SubjectDTO } from "utils/helpers/models/organization/subject.dto";
import { SuperAdminDTO } from "utils/helpers/models/organization/super-admin.dto";

export const ORGANIZATION_APIS = {
  loginAsAdmin: (body: any) => postRequest("/admin/login-as-admin", body),
  createOrganization: (body: any) => postRequest("/super/organizations", body),
  updateOrganization: (body: any, id: number) =>
    postRequest(`/super/organizations/update/${id}`, body),
  deleteOrganization: (id: number) =>
    deleteRequest(`/super/organizations/${id}`),
  getOrganizationById: (id: number) => getRequest(`/super/organizations/${id}`),
  getOrganizations: (params: any) => getRequest(`/super/organizations`, params),
  downloadOrganizationsPdfFile: () =>
    getRequest(`/super/organizations/download/pdf`),
  downloadOrganizationsExcelFile: () =>
    getRequest(`/super/organizations/download/excel`),
  createStructureTypeSuperAdmin: (body: any) =>
    postRequest("/super/categories_types", body),
  updateStructureTypeSuperAdmin: (body: any, structureTypeId: number) =>
    putRequest(`/super/categories_types/${structureTypeId}`, body),
  deleteStructureTypeSuperAdmin: (structureTypeId: number) =>
    deleteRequest(`/super/categories_types/${structureTypeId}`),
  getStructureTypeByIdSuperAdmin: (structureTypeId: number) =>
    getRequest(`/super/categories_types/${structureTypeId}`),
  getStructureTypesSuperAdmin: (params: any) =>
    getRequest(`/super/categories_types`, params),
  createStructureTypeAdmin: (body: any) =>
    postRequest("/admin/categories_types", body),
  updateStructureTypeAdmin: (body: any, id: number) =>
    putRequest(`/admin/categories_types/${id}`, body),
  deleteStructureTypeAdmin: (id: number) =>
    deleteRequest(`/admin/categories_types/${id}`),
  getStructureTypeByIdAdmin: (id: number) =>
    getRequest(`/admin/categories_types/${id}`),
  getStructureTypesAdmin: (params: any) =>
    getRequest(`/admin/categories_types`, params),
  createOrgStructure: (body: any) => postRequest("/admin/categories", body),
  updateOrgStructure: (body: any, id: number) =>
    postRequest(`/admin/categories/update/${id}`, body),
  deleteOrgStructure: (id: number) => deleteRequest(`/admin/categories/${id}`),
  getOrgStructureById: (id: number) => getRequest(`/admin/categories/${id}`),
  getAdminOrgStructures: (params: any) =>
      getRequest(`/admin/categories`, params),
  getOrgStructures: (params: any) =>
    getRequest(`/admin/list/categories`, params),
  createProgram: (body: any) => postRequest("/admin/programs", body),
  updateProgram: (body: any, id: number) =>
    patchRequest(`/admin/programs/${id}`, body),
  deleteProgram: (id: number) => deleteRequest(`/admin/programs/${id}`),
  getWhatsAppTemplates: (params: any) =>
    getRequest(`/admin/whatsapp/templates`, params),
  createWhatsAppTemplate: (body: any) =>
    postRequest(`/admin/whatsapp/templates`, body),
  updateWhatsAppTemplate: (body: any, id: number) =>
    putRequest(`/admin/whatsapp/templates/${id}`, body),
  deleteWhatsAppTemplate: (id: number) =>
    deleteRequest(`/admin/whatsapp/templates/${id}`),
  getWhatsAppTemplateById: (id: number) =>
    getRequest(`/admin/whatsapp/templates/${id}`),
  syncWhatsAppTemplates: () =>
    postRequest(`/admin/whatsapp/sync-templates`, {}),
  toggleWhatsAppTemplateActive: (id: number) =>
    patchRequest(`/admin/whatsapp/templates/${id}/toggle-active`, {}),
  getSmsTemplates: (params: any) =>
    getRequest(`/admin/sms_templates`, params),
  getAllSmsTemplates: () =>
    getRequest(`/admin/sms_templates/get_all`),
  createSmsTemplate: (body: any) =>
    postRequest(`/admin/sms_templates`, body),
  updateSmsTemplate: (body: any, id: number) =>
    putRequest(`/admin/sms_templates/${id}`, body),
  deleteSmsTemplate: (id: number) =>
    deleteRequest(`/admin/sms_templates/${id}`),
  getSmsTemplateById: (id: number) =>
    getRequest(`/admin/sms_templates/${id}`),
  toggleSmsTemplateActive: (id: number) =>
    patchRequest(`/admin/sms_templates/${id}/toggle-active`, {}),
  getPrograms: (params: any) => getRequest(`/admin/programs`, params),

  downloadStudentTranscript: (reg_number: any) =>
    getRequest(`/admin/academic/student/transcript`, { reg_number }),
  downloadStudentDeclaredResultTranscript: (params: any) =>
    getRequest(`/admin/academic/student/declared-result/transcript/pdf`, params),
  downloadStudentProvisionalTranscript: (params: any) =>
    getRequest(`/admin/academic/student/provisional-transcript/pdf`, params),
  issueStudentDeclaredResultTranscript: (params: any) =>
    getRequest(`/admin/academic/student/issue-declared-result/transcript/pdf`, params),
  verifyStudentRegistration: (params: any) =>
    getRequest(`/admin/academic/student/verify-registration`, params),
  downloadSemesterGradeSheet: (params: any) =>
    getRequest(`/admin/academic/student/semester-gradesheet/pdf`, params),
  downloadProvisionalGradeSheet: (params: any) =>
    getRequest(`/admin/academic/student/semester-provisional-gradesheet/pdf`, params),

  getProgramsForEntryTest: (params: any) =>
    getRequest(`/admin/programs/list/status`, params),
  getProgramById: (id: number) => getRequest(`/admin/programs/${id}`),
  downloadProgramsPdfFile: () => getRequest(`admin/programs/download/pdf`),
  downloadProgramsExcelFile: () => getRequest(`admin/programs/download/excel`),
  getCitiesSuperAdmin: (params: any) => getRequest(`/super/cities`, params),
  getDistrictsSuperAdmin: (params: any) =>
    getRequest(`/super/districts/list`, params),
  getStatesSuperAdmin: (params: any) =>
    getRequest(`/super/states/list`, params),
  getCitiesAdmin: (params: any) => getRequest(`/admin/cities`, params),
  getDistrictsAdmin: (params: any) =>
    getRequest(`/admin/districts/list`, params),
  getStatesAdmin: (params: any) => getRequest(`/super/states/list`, params),
  getCertificateLevels: (params: any) =>
    getRequest(`admin/certificatelevels`, params),
  getCertificateLevelsDropdown: () =>
    getRequest(`admin/certificatelevels/dropdown`),
  getCertificateLevelById: (id: number) =>
    getRequest(`admin/certificatelevels/${id}`),
  createCertificateLevel: (body: any) =>
    postRequest(`admin/certificatelevels`, body),
  updateCertificateLevel: (id: number, body: any) =>
    putRequest(`admin/certificatelevels/${id}`, body),
  deleteCertificateLevel: (id: number) =>
    deleteRequest(`admin/certificatelevels/${id}`),
  downloadCertificateLevelsPdfFile: () =>
    getRequest(`admin/certificatelevels/download/pdf`),
  downloadCertificateLevelsExcelFile: () =>
    getRequest(`admin/certificatelevels/download/excel`),
  getDepartmentsByStructureTypeId: (id: number) =>
    getRequest(`admin/departments/${id}`),
  getDepartmentsByCampusId: (id: number) =>
    getRequest(`admin/departments/campus/${id}`),
  downloadOrgStructuresExcelFile: () =>
    getRequest(`admin/categories/download/excel`),
  downloadOrgStructuresPdfFile: () =>
    getRequest(`admin/categories/download/pdf`),
  downloadStructureTypesExcelFileByAdmin: () =>
    getRequest(`admin/categories_types/download/excel`),
  downloadStructureTypesPdfFileByAdmin: () =>
    getRequest(`admin/categories_types/download/pdf`),
  downloadStructureTypesExcelFileBySuperAdmin: () =>
    getRequest(`super/categories_types/download/excel`),
  downloadStructureTypesPdfFileBySuperAdmin: () =>
    getRequest(`super/categories_types/download/pdf`),
  createResultTypeAdmin: (body: any) => postRequest(`admin/resulttypes`, body),
  updateResultTypeAdmin: (id: number, body: any) =>
    putRequest(`admin/resulttypes/${id}`, body),
  getResultTypesAdmin: (params: any) => getRequest(`admin/resulttypes`, params),
  getResultTypeByIdAdmin: (id: number) => getRequest(`admin/resulttypes/${id}`),
  deleteResultTypeAdmin: (id: number) =>
    deleteRequest(`admin/resulttypes/${id}`),
  createBoard: (body: AddBoardDTO) => postRequest(`admin/boards`, body),
  updateBoard: (id: number, body: AddBoardDTO) =>
    putRequest(`admin/boards/${id}`, body),
  getBoards: (params: any) => getRequest(`admin/boards`, params),
  getBoardById: (id: number) => getRequest(`admin/boards/${id}`),
  deleteBoard: (id: number) => deleteRequest(`admin/boards/${id}`),
  createSubject: (body: SubjectDTO) => postRequest(`admin/subjects`, body),
  updateSubject: (id: number, body: SubjectDTO) =>
    putRequest(`admin/subjects/${id}`, body),
  deleteSubject: (id: number) => deleteRequest(`admin/subjects/${id}`),
  getSubjectById: (id: number) => getRequest(`admin/subjects/${id}`),
  getSubjects: (params: any) => getRequest(`admin/subjects`, params),
  createDegreeCertificate: (body: any) =>
    postRequest(`admin/degreecertificates`, body),
  updateDegreeCertificate: (id: number, body: any) =>
    putRequest(`admin/degreecertificates/${id}`, body),
  getDegreeCertificates: (params: any) =>
    getRequest(`admin/degreecertificates`, params),
  getDegreeCertificateById: (id: number) =>
    getRequest(`admin/degreecertificates/${id}`),
  deleteDegreeCertificate: (id: number) =>
    deleteRequest(`admin/degreecertificates/${id}`),
  createLinkSpecialization: (body: AddLinkSpecialization) =>
    postRequest(`admin/linked_specializations`, body),
  updateLinkSpecialization: (id: number, body: AddLinkSpecialization) =>
    putRequest(`admin/linked_specializations/${id}`, body),
  getLinkSpecializations: (params: any) =>
    getRequest(`admin/linked_specializations`, params),
  deleteLinkSpecialization: (id: number) =>
    deleteRequest(`admin/linked_specializations/${id}`),
  getLinkSpecializationById: (id: number) =>
    getRequest(`admin/linked_specializations/${id}`),
  createEntryTestLink: (body: any) =>
    postRequest(`admin/entry_test_link_program`, body),
  updateEntryTestLink: (id: number, body: any) =>
    putRequest(`admin/entry_test_link_program/${id}`, body),
  getEntryTestLinks: (params: any) =>
    getRequest(`admin/entry_test_link_program`, params),
  getEntryTestLinkById: (id: number) =>
    getRequest(`admin/entry_test_link_program/${id}`),
  deleteEntryTestLink: (id: number) =>
    deleteRequest(`admin/entry_test_link_program/${id}`),
  createPermission: (body: AddPermissionDTO) =>
    postRequest(`super/permissions`, body),
  deletePermission: (id: number) => deleteRequest(`super/permissions/${id}`),
  getPermissions: (params: any) => getRequest(`super/permissions`, params),
  getPermissionsByAdmin: (params: any) =>
    getRequest(`admin/roles/permissions/list`, params),
  createCertificateLink: (body: any) =>
    postRequest(`admin/certificate_link_result_type`, body),
  updateCertificateLink: (id: number, body: any) =>
    putRequest(`admin/certificate_link_result_type/${id}`, body),
  getCertificateLinks: (params: any) =>
    getRequest(`admin/certificate_link_result_type`, params),
  getCertificateLinkById: (id: number) =>
    getRequest(`admin/certificate_link_result_type/${id}`),
  deleteCertificateLink: (id: number) =>
    deleteRequest(`admin/certificate_link_result_type/${id}`),
  createRoleBySuperAdmin: (body: any) => postRequest(`super/roles`, body),
  updateRoleBySuperAdmin: (id: number, body: any) =>
    putRequest(`super/roles/${id}`, body),
  getRolesBySuperAdmin: (params: any) => getRequest(`super/roles`, params),
  getRoleByIdBySuperAdmin: (id: number) => getRequest(`super/roles/${id}`),
  deleteRoleBySuperAdmin: (id: number) => deleteRequest(`super/roles/${id}`),
  createRoleByAdmin: (body: any) => postRequest(`admin/roles`, body),
  updateRoleByAdmin: (id: number, body: any) =>
    putRequest(`admin/roles/${id}`, body),
  getRolesByAdmin: (params: any) => getRequest(`admin/roles`, params),
  getRoleAssignedUsersByAdmin: (role_id: number) =>
    getRequest(`admin/roles/users/by-role`, { role_id }),
  getRoleByIdByAdmin: (id: number) => getRequest(`admin/roles/${id}`),
  deleteRoleByAdmin: (id: number) => deleteRequest(`admin/roles/${id}`),
  createSuperAdmin: (body: SuperAdminDTO) =>
    postRequest(`super/super_admins`, body),
  updateSuperAdmin: (id: number, body: SuperAdminDTO) =>
    putRequest(`super/super_admins/${id}`, body),
  getSuperAdmins: (params: any) => getRequest(`super/super_admins`, params),
  getSuperAdminById: (id: number) => getRequest(`super/super_admins/${id}`),
  deleteSuperAdmin: (id: number) => deleteRequest(`super/super_admins/${id}`),
  createBuilding: (body: any) => postRequest(`admin/buildings`, body),
  updateBuildingByID: (id: number, body: any) =>
    postRequest(`/admin/buildings/${id}`, body),
  // getInfrastructureBuildingList: (params: any) =>
  //   getRequest(`/admin/buildings`, params),
  getBuildingListForAddRoom: () => getRequest("/admin/buildings"),
  // getInfrastructureBuildingById: (id: number) =>
  //   getRequest(`/admin/buildings/${id}`),
  deleteInfrastructureItem: (id: number) =>
    deleteRequest(`/admin/buildings/${id}`),
  getBuildings: (params: any) => getRequest(`/admin/buildings`, params),
  getCampus: (params: any) => getRequest(`/admin/campuses`, params),
  getCampusFaculties: (id: number) => getRequest(`/admin/faculties/${id}`),
  getBuildingById: (id: number) => getRequest(`/admin/buildings/${id}`),
  deleteBuilding: (id: any) => deleteRequest(`/admin/buildings/${id}`),

  getRoomListForBuildingRooms: (params: any) =>
    getRequest(`/admin/rooms`, params),
  getBuildingRoomForupdate: (id: number) => getRequest(`/admin/rooms/${id}`),
  deleteRoomListItem: (id: any) => deleteRequest(`/admin/rooms/${id}`),
  createRoomForBuilding: (body: any) => postRequest("/admin/rooms", body),
  updateRoomForBuilding: (id: number, body: AddRoomDto) =>
    postRequest(`/admin/rooms/update/${id}`, body),

  getRoomTypesList: (params: any) => getRequest(`admin/room_types`, params),
  getRoomTypeById: (id: number) => getRequest(`admin/room_types/${id}`),
  createRoomType: (body: any) => postRequest(`admin/room_types`, body),
  updateRoomType: (id: number, body: any) =>
    putRequest(`admin/room_types/${id}`, body),
  deleteRoomType: (id: number) => deleteRequest(`admin/room_types/${id}`),

  getBuildingTypes: (params: any) => getRequest(`admin/building_types`, params),
  getBuildingTypeById: (id: number) => getRequest(`admin/building_types/${id}`),
  createBuildingType: (body: any) => postRequest(`admin/building_types`, body),
  updateBuildingType: (id: number, body: any) =>
    putRequest(`admin/building_types/${id}`, body),
  deleteBuildingType: (id: number) =>
    deleteRequest(`admin/building_types/${id}`),

  getAssetTypes: (params: any) => getRequest(`admin/asset_types`, params),
  getAssetTypeById: (id: number) => getRequest(`admin/asset_types/${id}`),
  createAssetType: (body: any) => postRequest(`admin/asset_types`, body),
  updateAssetType: (id: number, body: any) =>
    putRequest(`admin/asset_types/${id}`, body),
  deleteAssetType: (id: number) => deleteRequest(`admin/asset_types/${id}`),
  getCurrentOrganization: () => getRequest(`get/current/organization`),
  getCurrentOrganizationSettings: () =>
    getRequest(`admin/get_organization_settings`),
  getPublicOrganizationSettings: () =>
    getRequest(`get/current/public_organization_settings`),
  getCountriesAdmin: (params: any) =>
    getRequest(`admin/countries/list`, params),
  getSpecificStructure: (params: any) =>
    getRequest(`admin/structures/list`, params),
  createAdmin: (body: AdminDTO<string>) => postRequest(`/org/admins`, body),
  updateAdmin: (id: number, body: AdminDTO<string>) =>
    putRequest(`/org/admins/${id}`, body),
  getAdmins: (params: any) => getRequest(`/org/admins`, params),
  getAdminById: (id: number) => getRequest(`/org/admins/${id}`),
  deleteAdmin: (id: number) => deleteRequest(`/org/admins/${id}`),
  getRoleByAdmin: (params: any) => getRequest(`admin/role/list`, params),
  UpdateAdminOrganization: (id: number, body: FormData) =>
    postRequest(`/admin/organizations/update/${id}`, body),
  getOrganizationForUpdate: () => getRequest(`get/current/organization`),
  getStateForOrganization: () => getRequest(`admin/states/list?country_id=167`),
  getCategoriesProgram: (id: number, params: any) =>
    getRequest(`/admin/list/categories?categories_types_id=${id}`, params),
  getStructureTypesForProgram: (params: any) =>
    getRequest(`/admin/categories_types?type=Department`, params),
  getProgramCategoryTypes: (params?: any) => getRequest(`/admin/program-category-types`, params),
  createProgramCategoryType: (body: any) => postRequest(`/admin/program-category-types`, body),
  getProgramCategoryTypeById: (id: number) => getRequest(`/admin/program-category-types/${id}`),
  updateProgramCategoryType: (id: number, body: any) => putRequest(`/admin/program-category-types/${id}`, body),
  deleteProgramCategoryType: (id: number) => deleteRequest(`/admin/program-category-types/${id}`),
  getOrgAdminById: (id: number) =>
    getRequest(`/super/admins/by_org?organization_id=${id}`),
  UpdateOrgAdminPassword: (id: number, body: UpdatePasswordDTO) =>
    putRequest(`/super/admins_by_org/reset_password/${id}`, body),
  getNestedOrgStructures: (params: any) =>
    getRequest(`user/get_all_nested_list`, params),
  getSpecificOrgStructures: (params: any) =>
    getRequest(`admin/get_by_type`, params),
  getDesignAndReviewList: (params: any) =>
    getRequest(`admin/design_and_review`, params),
  createDesignAndReview: (data: FormData) =>
    postRequest("admin/design_and_review", data),

  getDesignAndReviewById: (id: number) =>
    getRequest(`admin/design_and_review/${id}`),

  updateDesignAndReview: (id: number, data: FormData) =>
    postRequest(`admin/design_and_review/update/${id}`, data),
  updateDesignAndReviewStatus: (data: FormData) =>
    postRequest(`admin/design_and_review/update_status`, data),

  deleteDesignAndReview: (id: number) =>
    deleteRequest(`admin/design_and_review/${id}`),
  getModulesList: (params: any) => getRequest(`admin/modules`, params),
  getAvailableModulesList: () => getRequest(`admin/modules/list`),
  createModule: (body: any) => postRequest(`admin/modules`, body),
  updateModule: (id: number, body: any) =>
    putRequest(`admin/modules/${id}`, body),
  getModuleById: (id: number) => getRequest(`admin/modules/${id}`),
  deleteModule: (id: number) => deleteRequest(`admin/modules/${id}`),
  downloadModulesPdf: () => getRequest(`admin/modules/download-pdf`),
  downloadModulesExcel: () => getRequest(`admin/modules/download-excel`),
  updateModuleSettings: (id: number, body: any) =>
    postRequest(`admin/modules/update_settings/${id}`, body),
  getModuleSettings: (id: number) =>
    getRequest(`admin/modules/get_settings/${id}`),

  // Access Templates Headers
  getAccessTemplateHeaders: (params: any) =>
    getRequest(`/admin/access_templates_headers`, params),
  getAccessTemplateHeaderById: (id: number) =>
    getRequest(`/admin/access_templates_headers/${id}`),
  createAccessTemplateHeader: (body: any) =>
    postRequest(`/admin/access_templates_headers`, body),
  updateAccessTemplateHeader: (body: any, id: number) =>
    putRequest(`/admin/access_templates_headers/${id}`, body),
  deleteAccessTemplateHeader: (id: number) =>
    deleteRequest(`/admin/access_templates_headers/${id}`),

  // Access Templates Body
  getAccessTemplateBodies: (params: any) =>
    getRequest(`/admin/access_templates_body`, params),
  getAccessTemplateBodyById: (id: number) =>
    getRequest(`/admin/access_templates_body/${id}`),
  createAccessTemplateBody: (body: any) =>
    postRequest(`/admin/access_templates_body`, body),
  updateAccessTemplateBody: (body: any, id: number) =>
    putRequest(`/admin/access_templates_body/${id}`, body),
  deleteAccessTemplateBody: (id: number) =>
    deleteRequest(`/admin/access_templates_body/${id}`),

  // Notifications
  getNotifications: (params: any) => getRequest("/admin/notifications", params),
  createNotification: (body: any) => postRequest("/admin/notifications", body),
  getNotificationById: (id: number) => getRequest(`/admin/notifications/${id}`),
  updateNotification: (id: number, body: any) =>
    putRequest(`/admin/notifications/${id}`, body),
  deleteNotification: (id: number) =>
    deleteRequest(`/admin/notifications/${id}`),
  getOrgStructureList: (params: any) =>
    getRequest(`admin/org_structure-list`, params),
  /** Full org tree without user_access filter (Access Template Body setup). */
  getOrgStructureFullList: (params?: any) =>
    getRequest(`admin/org_structure-full-list`, params),
  getProgramsList: () => getRequest(`admin/programs-list`),
};
